module.exports = __webpack_public_path__ + "static/media/7x7GoodOptimized.b2a5b374.webp";